/* eslint-disable arrow-body-style */
import React from 'react';
import { HeaderOrigination } from '@honeycomb-npm/honeycomb-react';
import { content } from '../../../utils/contentUtils';

import './Header.scss';

export interface Props {
  closeModalOpen: () => void;
}

const Header = ({ closeModalOpen }: Props) => {
  return (
    <HeaderOrigination
      id="claim-refund-header"
      closeText={content.header.closeText}
      onClick={closeModalOpen}
      buttonAttributes={{ id: 'header-close-button' }}
      className="claim-refund-header--fixed"
    />
  );
};

export default Header;
